var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Slider',{attrs:{"min":_vm.min,"max":_vm.max},on:{"change":function($event){return _vm.$emit('setRange',$event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }